import axios from 'axios'
import api from '@/api'

const patientsNfzList = {
  state: {
    data: []
  },
  getters: {
    getPatientsNfzList: state => state.data
  },
  mutations: {
    PATIENT_NFZ_LIST_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsNfzListGet (context) {
      axios({
        method: 'get',
        url: `${api}patients/nfzs`,
      }).then(response => {
        context.commit('PATIENT_NFZ_LIST_GET', response.data.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default patientsNfzList
